import type { ReactNode } from 'react';

export const symbol_mobile_arrow_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Zm277-350-54 53q-9 9-8.5 21t9.5 21q9 9 21 9t21-9l103-104q5-5 7-10.13 2-5.14 2-11 0-5.87-2-10.87-2-5-7-10L525-605q-9-9-20.5-9t-20.5 9q-9 9-9 21t9 21l53 53H339q-13 0-21 8.68-8 8.67-8 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h197Z"
		/>
	</svg>
);
